
import { defineComponent } from "vue";
import privacy from "../../components/sections/PrivacyPolicyView.vue";
import ContainerView from "@/components/sections/ContainerView.vue";
import CardView from "@/components/controls/CardView.vue";

export default defineComponent({
    name: "PrivacyPolicyView",
    components: {
        privacy,
        ContainerView,
        CardView
    },
    mounted() {
        this.$emit('scrolltop');
    },
})
